import { useContextTS } from "@inrange/utils";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import getReports from "../http/getReports";
import postReports from "../http/postReports";
import { ReloginContext } from "../ReloginContext";
import { getAuthTokenBlocking } from "./utils";

const useReports = (refetchInterval?: number | false) => {
  const queryClient = useQueryClient();
  const { getToken } = useKindeAuth();
  const { relogin } = useContextTS(ReloginContext);

  const fetchReports = useQuery(
    ["reports"],
    async () => {
      return getReports(await getAuthTokenBlocking(getToken, relogin));
    },
    { refetchInterval: refetchInterval }
  );

  const invokeReports = useMutation(
    async () => postReports(await getAuthTokenBlocking(getToken, relogin)),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["reports"]);
      },
    }
  );

  return {
    invokeReports,
    fetchReports,
  };
};

export default useReports;
